export const sendVote = (vote, token, callback) => {
    fetch(`${ApiUrl()}?token=${token}`, 
    {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(vote)
    }).then(res => res.text())
}

const ApiUrl = () => {
    if(window.location.hostname.includes("localhost")){
        return "https://localhost:44333/Votes"
    } else if(window.location.hostname.includes("qa-a")){
        return "https://qa-a.ynet.co.il/mShort/content/api/gamesparade/votes";
    } else {
        return "https://z.ynet.co.il/mShort/content/api/gamesparade/votes";
    }
}